module.exports = __webpack_public_path__ + "static/media/feature.3f63975b.jpg";